import React, { useEffect, useState } from 'react'
import Hero from './../../components/common/Hero/hero';
import PopularPlaces from './../../components/popular-places/popularPlaces';
import FeaturedProperties from './../../components/featured-property/featuredProperties';
import WhyChooseUs from './../../components/why-choose-us/whyChooseUs';
import DiscoverProperties from './../../components/discover-properties/discoverProperties';
import MeetOurAgent from './../../components/meetOurAgents/meetOurAgent';
import Testimonial from './../../components/testimonial/testimonial';
import OurPartner from './../../components/our-partner/ourPartner';
import PropertyByArea from '../common/propertyByArea';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedOptionsRequest } from './actions';
import request from '../../service/request';
import { Helmet } from 'react-helmet';
import TheTatvaHome from '../theTatvaHome';
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const Landing = (props) => {
  const menu = useSelector(store => store.commonPageData.menu.length > 0 ? store.commonPageData.menu : store.commonPageData.menu)
  const dispatch = useDispatch();
  const [setting, setSetting] = useState([]);
  const [title, setTitle] = useState([]);
  const params = {
    hot_property: '',
    property_type: '',
    property_for: '',
    specific_property: '',
    measurement: '',
    area_size: '',
    area: '',
    country: 101,
    page: 1,
    property_configuration: ''
  };

  useEffect(() => {
    scrollToTop();
    document.body.classList.remove('inner-pages', 'homepage-4', 'agents', 'hp-6', 'full', 'hd-white');
    document.body.classList.add('homepage-9', 'hp-6', 'homepage-1', 'mh');
    document.getElementById("header-container").classList.add('header', 'head-tr');

    dispatch(setSelectedOptionsRequest(params));
  }, [props.match.params]);

  useEffect(() => {
    request({
      method: 'get',
      url: '/get-menu',
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
    })
      .then((response) => {
        setTitle(response?.data);
      })
      .catch(({ data }) => ({ error: data }));
  }, []);

  useEffect(() => {
    if (menu && menu.code == 0) {
      setSetting(menu.data.site_setting);
    }
  }, [menu]);
  return (
    <>
      <Helmet>
        <title>{title.data?.site_setting?.site_name}</title>
      </Helmet>
      {
        process.env.REACT_APP_ENDPOINT == "thetatva" 
          ? <TheTatvaHome/>
          : (
          <>
            <Hero />
            <FeaturedProperties />
            <DiscoverProperties />
            <WhyChooseUs />
            <MeetOurAgent />
            <Testimonial />
            <OurPartner />
          </>
      )}

      {/* <Hero /> */}
      {/* <PopularPlaces /> */}
      {/* <FeaturedProperties />
      <DiscoverProperties />
      <WhyChooseUs />
      <MeetOurAgent />
      <Testimonial />
      <OurPartner /> */}
      {/* {
        setting && setting.areas_of_city && setting.areas_of_city == "yes" &&
        <PropertyByArea />
      } */}
    </>
  )
}

export default Landing
